module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'jobs',
        showHead: true,
        showIDs: true,
        showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {},
        rowActionsInline: true,
        rowActionsProperties: {
            colWidth: '75px',
        },
        rowActions: {
            edit: true,
            customs: [
                // {
                //     buttonType: 'showLocation',
                // },
                {
                    buttonType: 'setActive',
                    neutral: true,
                },
                {
                    buttonType: 'setInactive',
                    neutral: true,
                }
            ]
        },
        addRowClassViaAttribute: {
            fieldCode:  'active',
            value:      true,
            class:      'isActive',
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_jobs': true,
        },
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'jobID',
                direction: 'desc'
            }]
        }
    },

    methods: {
        onPrepareDone(){
            this.config.customHeadActionsFormMapping = {
                buttons: [
                    { buttonType: 'showInsert', context: this.config.buttonContext, positive: true, privilegeCode: 'bo_jobs:create', }
                ]
            }
        },

        async setActive(entityID, entityData){
            if(entityID){
                await this.performAction(this.prepareAction('edit_jobs', entityID, undefined, {
                    source: {
                        submit: {
                            data: {
                                data: {
                                    attributes: {
                                        active: true
                                    }
                                }
                            }
                        }
                    }
                }))
            }
        },
        async setInactive(entityID, entityData){
            if(entityID){
                await this.performAction(this.prepareAction('edit_jobs', entityID, undefined, {
                    source: {
                        submit: {
                            data: {
                                data: {
                                    attributes: {
                                        active: false
                                    }
                                }
                            }
                        }
                    }
                }))
            }
        },
    },
}